<template>
  <div
    :class="[
      wrapperClass,
      {
        'has-error has-danger':
        (validator && validator.$error) || (errors && !wrapped),
      },
    ]"
  >
    <div
      v-if="wrapped"
      :id="'textarea-wrapper-' + id"
      :class="[
        { 'has-error has-danger': (validator && validator.$error) || errors },
        textareaWrapperClass,
      ]"
    />
    <slot name="icon" />
    <div
      :class="[
        'container__form',
        { validateInput: validator ? !validator.$error : field },
      ]"
    >
      <textarea
        :id="id"
        :rows="rows"
        v-model.trim="field"
        :placeholder="placeholder"
        :class="[textareaClass]"
        class="form-control container__input"
        @blur="
          $emit('blur');
          !validator || validator.$touch();
        "
      />
      <!-- <label :class="[labelClass]"
             :for="id"
             class="container__label"> {{ label }}<span v-if="validator && validator.$params.required">*</span></label> -->
    </div>
    <div
      :id="'textarea-help-block-' + id"
      class="help-block form-text form-control-feedback"
    >
      <template v-for="(error, index) in errors">
        <strong :key="index"> {{ error }} </strong>
      </template>
      <!-- <strong v-if="validator && validator.$params.required && validator.$error && !validator.required">{{ label.toLowerCase() }} is required!</strong> -->
    </div>
  </div>
</template>

<script>
export default {
	name: 't-textarea',
	props: {
		label: {
			type: String,
			default: 'TextArea'
		},
		value: {
			type: String,
			default: null
		},
		lowerCase: {
			type: Boolean,
			default: false
		},
		upperCase: {
			type: Boolean,
			default: false
		},
		rows: {
			type: Number,
			default: 3
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		textareaClass: {
			type: String,
			default: 'form-control'
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		textareaWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		validator: {
			type: Object,
			default: null
		},
		placeholder: {
			type: String,
			default: ''
		},
		wrapped: {
			type: Boolean,
			default: false
		},
		autofocus: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => {
				return null
			}
		}
	},
	computed: {
		field: {
			get () {
				return this.value
			},
			set (value) {
				if (!value) value = null
				// else if (this.type === 'number' && !value && parseInt(value) !== 0) value = null
				// parseInt(value) === 0
				if (value) {
					if (this.lowerCase) {
						value = value.toLowerCase()
						this.$emit('input', value ? value.trim() : value)
						return
					}

					if (this.upperCase) {
						value = value.toUpperCase()
						this.$emit('input', value ? value.trim() : value)
						return
					}
				}

				this.$emit('input', value)
			}
		},
		id () {
			return 't-textarea-' + Math.random().toString().replace('0.', '')
		}
	},
	mounted () {
		let textarea = document.getElementById(this.id)
		if (this.wrapped) {
			let wrapper = document.getElementById(`textarea-wrapper-${this.id}`)
			let helpBlock = document.getElementById(`textarea-help-block-${this.id}`)
			wrapper.appendChild(textarea)
			wrapper.appendChild(helpBlock)
		}
		if (this.autofocus) textarea.focus()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/common/textarea/index.vue